import { render, staticRenderFns } from "./NewToolbar.vue?vue&type=template&id=d633278e"
import script from "./NewToolbar.vue?vue&type=script&lang=ts"
export * from "./NewToolbar.vue?vue&type=script&lang=ts"
import style0 from "./NewToolbar.vue?vue&type=style&index=0&id=d633278e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports